import React, { useState } from "react";
// import "./industrialSubsidy.css";
import { Link } from "react-router-dom";

const services = [
  { name: "Nabard - AMI Scheme", path: "/subsidy/ami" },
    { name: "AIF - Interest Subvention", path: "/subsidy/aif" },
      { name: "Mega Food Park", path: "/subsidy/mega-food-park" },
      { name: "CEFPPC", path: "/subsidy/cefppc" },
  { name: "Agro Processing Cluster", path: "/subsidy/apc" },
  { name: "Cold Chain", path: "/subsidy/cold-chain" },
  { name: "Operation Greens", path: "/subsidy/operation-greens" },
  { name: "CBFL", path: "/subsidy/cbfl" },
  { name: "Food Testing Laboratories", path: "/subsidy/ftl" },
  { name: "Cold Storage Industry", path: "/subsidy/cold-storage" },
   { name: "Open Field", path: "/subsidy/open-field" },
          { name: "Protected Cover", path: "/subsidy/protected-cover" },
          { name: "Integrated Post Harvest", path: "/subsidy/post-harvest" },
  { name: "Cluster Development", path: "/subsidy/cluster" },
   { name: "MSME - CLCSS", path: "/subsidy/clcss" },
          { name: "APEDA - Financial Assistance", path: "/subsidy/apeda" },

  // { name: "Food Processing Industry", path: "/subsidy/food-processing" },
  // { name: "Farming Related Industry", path: "/subsidy/farming" },
  // { name: "Textile Industry", path: "/subsidy/textile" },
  // { name: "Seed Industry", path: "/subsidy/seed" },
  
  // { name: "Commercial Horticulture Industry", path: "/subsidy/horticulture" },  
  // { name: "NHB/NHM - Cold Storage Subsidy", path: "/subsidy/cold-storage" },
  // { name: "Commercial Horticulture - Open Field", path: "/subsidy/open-field" },
  // { name: "Commercial Horticulture - Protected Cover", path: "/subsidy/protected-cover" },
  // { name: "Integrated Post Harvest", path: "/subsidy/post-harvest" },
  // { name: "NHB - Cluster Development", path: "/subsidy/cluster" },
  // { name: "Telangana State Food Processing Policy", path: "/subsidy/ts-policy" },
  // { name: "CLCSS", path: "/subsidy/clcss" },
  // { name: "Nabard - Poultry Scheme", path: "/subsidy/poultry" },
  // { name: "NSC - Seed Processing units", path: "/subsidy/nsc" },
  // { name: "APEDA - Financial Assistance", path: "/subsidy/apeda" },
  // { name: "SFAC - VCA Interest Free Loan", path: "/subsidy/sfac" },
];

export default function IndustrialSubsidyPage() {
  const [open, setOpen] = useState(null);

  return (
    <div className="subsidy-page">

      {/* HERO */}
      <section className="subsidy-hero">
        <div className="overlay">
          <div className="container">
            <h1>Industrial Subsidy Consultants</h1>
            <p>Home Back » Industrial Subsidies</p>
          </div>
        </div>
      </section>

      {/* MAIN */}
      <section className="subsidy-main container">

        {/* LEFT */}
        <aside className="subsidy-left">

          <div className="left-menu-wrapper">

             <Link to="/dgft" className="left-menu-item">
              <span>DGFT Liaisoning (EXIM)</span>
              <span>▸</span>
            </Link>

            <div className="left-menu-item active">
              <span>Industrial Subsidies</span>
              <span>▸</span>
            </div>

          </div>

          <h3 className="info-title">Get Information</h3>

          {/* <div className="brochure">
            <span>📄 Corporate Brochure</span>
            <span>⬇</span>
          </div> */}

          {/* <div className="contact-box">
            <h4>Got any Questions?</h4>
            <h2>Call Us Today</h2>
            <p>040 4850 3467</p>
            <small>info@enrichservices.in</small>
          </div> */}

        </aside>

        {/* RIGHT */}
        <div className="subsidy-right">

          <h2>Industrial Subsidies</h2>

          <p>
            Funding is a major challenge for every entrepreneur. Government
            promotes industries by providing financial assistance.
          </p>

          <h3>We operate in the following industries:</h3>

          <div className="accordion">
            {services.map((item, index) => (
              <div key={index} className="acc-item">

                <div
                  className="acc-title"
                  onClick={() =>
                    setOpen(open === index ? null : index)
                  }
                >
                  <Link to={item.path} className="service-link">
  {item.name}
</Link>
                  <span>{open === index ? "−" : "+"}</span>
                </div>

                {open === index && (
                  <div className="acc-content">
                    Detailed information about {item}.
                  </div>
                )}

              </div>
            ))}
          </div>

        </div>

      </section>
    </div>
  );
}